import React from "react";
import { Box, Tooltip, Button } from "@material-ui/core";

import { Check, Close, Description, Replay } from "@material-ui/icons";

export const importTransformColumn = (
  impDisplayColumns: any,
  getWeBOCFileDetails: any,
  weBOCFileGenerateHandler: any,
  formik: any,
  setImpDisplayColumns: any
) => {
  const transformedColumns: any = impDisplayColumns.map((column: any) =>
    column.accessorKey === "isCRLOReceived"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <React.Fragment>
                <Box>
                  <Tooltip title={row.original?.isCRLOReceived ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isCRLOReceived ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isCRLOReceived ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>

                  {row.original?.isCRLOReceived && (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "CRLO",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </React.Fragment>
            );
          },
        }
      : column.accessorKey === "isECMOReceived"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <React.Fragment>
                <Box>
                  <Tooltip title={row.original?.isECMOReceived ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isECMOReceived ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isECMOReceived ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isECMOReceived && (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "ECMO",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </React.Fragment>
            );
          },
        }
      : column.accessorKey === "isGDIOReceived"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <React.Fragment>
                <Box>
                  <Tooltip title={row.original?.isGDIOReceived ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isGDIOReceived ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isGDIOReceived ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isGDIOReceived && (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "GDIO",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </React.Fragment>
            );
          },
        }
      : column.accessorKey === "isGTOOSent"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <React.Fragment>
                <Box>
                  <Tooltip title={row.original?.isGTOOSent ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isGTOOSent ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isGTOOSent ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isGTOOSent ? (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "GTOO",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  ) : (
                    row.original.gatePassId !== 0 && (
                      <Tooltip title="Generate">
                        <Button
                          style={{
                            minWidth: "30px",
                            padding: "4px",
                            color: "#0d99ff",
                          }}
                          onClick={() =>
                            weBOCFileGenerateHandler(
                              row.original.gatePassId,
                              row.original.webocVehicleNumber,
                              "GTOO",
                              formik.values.processType,
                              formik.values.gdNumber
                            )
                          }
                        >
                          <Replay />
                        </Button>
                      </Tooltip>
                    )
                  )}
                </Box>
              </React.Fragment>
            );
          },
        }
      : column.accessorKey === "isIHCOReceived"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <React.Fragment>
                <Box>
                  <Tooltip title={row.original?.isIHCOReceived ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isIHCOReceived ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isIHCOReceived ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isIHCOReceived && (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "IHCO",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </React.Fragment>
            );
          },
        }
      : column.accessorKey === "isSRCOSent"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <React.Fragment>
                <Box>
                  <Tooltip title={row.original?.isSRCOSent ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isSRCOSent ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isSRCOSent ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isSRCOSent ? (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "SRCO",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  ) : (
                    row.original.gatePassId !== 0 && (
                      <Tooltip title="Generate">
                        <Button
                          style={{
                            minWidth: "30px",
                            padding: "4px",
                            color: "#0d99ff",
                          }}
                          onClick={() =>
                            weBOCFileGenerateHandler(
                              row.original.gatePassId,
                              row.original.webocVehicleNumber,
                              "SRCO",
                              formik.values.processType,
                              formik.values.gdNumber
                            )
                          }
                        >
                          <Replay />
                        </Button>
                      </Tooltip>
                    )
                  )}
                </Box>
              </React.Fragment>
            );
          },
        }
      : column.accessorKey === "isVGILReceived"
      ? {
          ...column,
          Cell: function customCell({ row }: any) {
            return (
              <React.Fragment>
                <Box>
                  <Tooltip title={row.original?.isVGILReceived ? "Yes" : "No"}>
                    <Button
                      style={{
                        minWidth: "30px",
                        padding: "4px",
                        color: `${row.original?.isVGILReceived ? "#72ca00" : "#eb0000"}`,
                      }}
                    >
                      {row.original?.isVGILReceived ? <Check /> : <Close />}
                    </Button>
                  </Tooltip>
                  {row.original?.isVGILReceived && (
                    <Tooltip title="File">
                      <Button
                        style={{
                          minWidth: "30px",
                          padding: "4px",
                          color: "#ed760d",
                        }}
                        onClick={() =>
                          getWeBOCFileDetails(
                            row.original.gatePassId,
                            row.original.webocVehicleNumber,
                            "VGIL",
                            formik.values.processType,
                            formik.values.gdNumber
                          )
                        }
                      >
                        <Description />
                      </Button>
                    </Tooltip>
                  )}
                </Box>
              </React.Fragment>
            );
          },
        }
      : column
  );

  setImpDisplayColumns(transformedColumns);
};
